var _g, _g2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMailRoundMark = function SvgMailRoundMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42.415
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "ik_cp_mail",
    transform: "translate(7.486 6.455)",
    fill: "#102b3f"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 316",
    cx: 21,
    cy: 21,
    r: 21,
    transform: "translate(-7.486 -6.455)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3251",
    d: "M-7.341 15.155v20.8l16.026-6.1Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6499"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6405",
    fill: "none",
    stroke: "#e8f5f5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3404",
    d: "M31.999 17.002v11.927a2.571 2.571 0 0 1-2.571 2.571H12.573a2.571 2.571 0 0 1-2.571-2.571V17.002"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3405",
    d: "m17.697 10 3.3-3 3.3 3"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 291",
    d: "M13.522 13.796 10 17.001"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 292",
    d: "m32 17.001-3.522-3.205"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3406",
    d: "m10.005 17.002 11 10 11-10"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 293",
    d: "m31.198 30.79-7.178-6.526"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 294",
    d: "m17.98 24.264-7.178 6.526"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3407",
    d: "M13.525 19.859v-9.86h14.95v9.86"
  })))));
};

export default SvgMailRoundMark;